import { useEffect } from 'react'
import eventBus, { TEventCallback } from './eventBus'
import { TEventType, EVENT_TYPES } from './eventTypes'

export const useSubscribeToEvent = (
  event: string | TEventType,
  callback: TEventCallback
): void => {
  useEffect(() => {
    const unsubscribe = eventBus.subscribe(event, callback)

    // Clean up subscription when component unmounts
    return unsubscribe
  }, [event, callback])
}

export { eventBus, EVENT_TYPES }
